import moment from 'moment';
import React from 'react'
import ReactDatePicker from 'react-datepicker';
import { Label } from 'reactstrap';
import { renderUploadedFiles } from '../../../utils/invoiceGeneration/commonFunctions';
import { CircularAvatar, DropDown } from '../../commons';
import { CalenderIcon, PaperClipIcon, UploadNew } from '../../Icon';
import { DropDownItemType, UserListType } from './AddEditDisbursementForm';
import Select,{ components } from 'react-select';

type AppProps = {
  handleInputDetailsChange: (data: any) => void;
  handleToggleFileUploadModal: (data: any) => void;
  inputDetails: any;
  formError: any;
  isEdit: boolean;
  date: string | null | undefined;
  finalClientList: [] | DropDownItemType[];
  finalJobList: [] | DropDownItemType[];
  finalUserList: UserListType[];
  handleChange:(data:any)=>void;
  userFetching: boolean;
  userSelected:any;
  setText:Function;
  setOffset:Function;
  limit:number;
  clientSelected: any;
  jobSelected: any;
  uploadData: any;
  renderFilesList: (data: any) => void;
  showPopUpContentModal: boolean;
  setShowPopUpContentModal: (data: any) => void;
  handleDateChange: (data: any) => void;
  handleChangeClient: (data: any) => void;
  handleChangeJob: (data: any) => void;
}
const DisbursementInputDetails = ({
  handleInputDetailsChange,
  inputDetails,
  date,
  isEdit,
  finalClientList,
  finalJobList,
  finalUserList,
  handleChange,
  userSelected,
  userFetching,
  setText,
  setOffset,
  limit,
  handleDateChange,
  handleChangeClient,
  handleChangeJob,
  clientSelected,
  uploadData,
  jobSelected,
  handleToggleFileUploadModal,
  renderFilesList,
  setShowPopUpContentModal,
  showPopUpContentModal,
  formError
}: AppProps) => {
  
 
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props} >
        <div className='d-flex justify-content-sm-start' style={{ gap: '10px' }}>
          <CircularAvatar name={data?.label} image={data?.image && data?.image} />
          {data?.label}
        </div>
      </components.Option>
    );
  };

  const checkBottom = (e: any) => {
    setOffset((prv: any) => prv + limit);
  };


  const prevent = (e: any) => {
    document.addEventListener('keypress', function (e) {
      if (e.keyCode === 13 || e.which === 13) {
        e.preventDefault();
        return false;
      }
    });
  }
  return (
    <>
      <div className='row'>
        <div className="col-4">
          <label>Select Client<span className='color-red'>*</span></label>
          <DropDown
            placeholder="Choose Client.."
            options={finalClientList}
            handleChange={handleChangeClient}
            value={clientSelected}
          />
        </div>
        <div className="col-4">
          <label>Select Job<span className='color-red'>*</span></label>
          <DropDown
            placeholder="Choose Job.."
            options={finalJobList}
            handleChange={handleChangeJob}
            value={jobSelected}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-4 mt-3'>
          <form>
            <div className='form-group'>
              <div>
                <label htmlFor='Title'>Title<span className='color-red'>*</span></label>
                <input
                  type="text"
                  name='title'
                  value={inputDetails?.title}
                  onChange={(e) => handleInputDetailsChange(e)}
                  className={`form-control ${!!formError?.titleError ? 'error-border' : null}`}
                />
                {!!formError?.titleError && (<small className='text-danger'>{formError?.titleError}</small>)}
              </div>
            </div>
          </form>
        </div>
        <div className='col-md-4 mt-3'>
          <form>
            <div className='form-group'>
              <div>
                <label htmlFor='Amount'>Amount</label>
                <input
                  type="number"
                  name='amount'
                  onClick={(e) => prevent(e)}
                  value={inputDetails?.amount}
                  onChange={(e) => handleInputDetailsChange(e)}
                  className='form-control'
                  onWheel={event => event.currentTarget.blur()}
                />
                {!isEdit && <span style={{ fontSize: "12px", color: "gray" }}>Mention amount of payment</span>}              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-4' style={{ marginTop: isEdit ? "" : '-12px' }}>
          <form>
            <div className='form-group'>
              <div>
                <label htmlFor='Paid from Bank Account & date'>Mode Of Payment</label>
                <input
                  className='form-control'
                  name='modeOfPayment'
                  type='text'
                  value={inputDetails?.modeOfPayment}
                  onChange={(e) => handleInputDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-4" style={{ marginTop: isEdit ? "" : '-12px' }}>
          <div className="form-group">
            <div className='date-picker-wraper mr-0'>
              <label>Payment Date</label>
              <Label className='m-0 p-0 w-100'>
                <ReactDatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={date ? new Date(moment(`${date}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                  onChange={(e: any) => { handleDateChange?.(moment(e).format('YYYY-MM-DD')) }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  name='dateOfInvoice'
                  placeholderText='Choose Date'
                  className='form-control'
                />
                <span className="calender-icon" style={{ right: '30px', cursor: 'pointer', marginTop: "22px" }}>
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-4'>
          <form>
            <div className='form-group'>
              <div>
                <label>Description of Payment</label>
                <textarea
                  className='form-control'
                  name='descriptionOfPayment'
                  value={inputDetails?.descriptionOfPayment}
                  onChange={(e) => handleInputDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>


        <div className='col-md-4'>
          <form>
            <div className='form-group'>
              <label>
                Access to team members
              </label>
              <Select
                className="dropdown"
                placeholder="Search User"
                value={userSelected[0]?.label ? userSelected : []}
                options={finalUserList}
                onChange={handleChange}
                isMulti
                isClearable
                components={{ Option }}
                isLoading={userFetching}
                isSearchable={true}
                onMenuScrollToBottom={(e: any) => checkBottom(e)}
                onInputChange={(e: string) => {
                  setText(e);
                  setOffset(0);
                }}
              />
              {!!formError?.accessMemberError && (<small className='text-danger'>{formError?.accessMemberError}</small>)}
            </div>
          </form>
        </div>
      </div>
      <div className='row'>
        <div className="col-md-4 mt-1 mb-3">
          {!!uploadData?.length && (
            <div className="pointer">
              <span id="Popover1">
                <PaperClipIcon />
                <span className="badge count-badge">
                  {uploadData?.length}
                </span>
              </span>
              {renderUploadedFiles(showPopUpContentModal, setShowPopUpContentModal, renderFilesList)}
            </div>
          )}
          <button
            className="btn btn-sm btn-outline mt-3"
            onClick={handleToggleFileUploadModal}
            disabled={!clientSelected?.value}
          >
            <span>
              <UploadNew /> Upload Files
            </span>
          </button>
        </div>
      </div>
    </>
  )
}

export default DisbursementInputDetails